const es = {
  labels: {
    eyebrow: "Sector estratégico · CEZ",
    contextoLabel: "El sector en contexto",
    datosLabel: "Datos rápidos",
    propuestaLabel: "Propuesta de valor",
    retosLabel: "Lo que hoy nos frena",
    mesaLabel: "Qué hace la mesa sectorial",
    volver: "Volver a Sectores",
    saberMas: "Saber más",
    ctaTitle: "¿Su empresa es de este sector?",
    ctaBody: "Únase a la mesa sectorial y participe en las decisiones, las compras conjuntas y los negocios entre afiliados.",
    cta: "Quiero participar en esta mesa",
  },
  sectores: {
    salud: {
      resumen:
        "Fusagasugá atiende pacientes de toda la provincia y recibe cada año más adultos mayores que llegan a vivir aquí. El sector salud es el corazón de la economía plateada del Sumapaz.",
      contexto: [
        "La provincia funciona como un nodo regional de servicios de salud: clínicas, centros de cuidado, laboratorios, farmacias, terapias y servicios a domicilio atienden a los diez municipios y a los visitantes que llegan de Bogotá.",
        "El envejecimiento del país juega a favor del Sumapaz: cada año más personas eligen la región para vivir su retiro por el clima, la cercanía a la capital y el costo de vida. Eso convierte al cuidado en un mercado estable, que no depende del fin de semana ni de la cosecha.",
      ],
      datos: [
        { valor: "10", texto: "Municipios que acuden a servicios de salud en Fusagasugá" },
        { valor: "2h", texto: "De Bogotá: pacientes y familias visitan sin trasteo" },
        { valor: "60+", texto: "La población mayor crece más rápido que el promedio nacional" },
        { valor: "365", texto: "Días de demanda: el cuidado no tiene temporada baja" },
      ],
      propuestaIntro:
        "La mesa de salud del CEZ convierte un sector fragmentado en un bloque que negocia, forma y compra en conjunto.",
      propuesta: [
        {
          titulo: "Negociación en bloque",
          texto:
            "Plazos y condiciones de pago negociados en conjunto con las pagadoras. Una clínica sola espera; sesenta empresas en bloque negocian.",
        },
        {
          titulo: "Talento formado aquí",
          texto:
            "Auxiliares y cuidadores formados con la academia local, para dejar de perder personal calificado que se va a Bogotá.",
        },
        {
          titulo: "Compras conjuntas",
          texto:
            "Insumos médicos y de cuidado comprados en volumen para bajar el costo unitario de cada afiliado.",
        },
        {
          titulo: "Red Fusagasugá Plateada",
          texto:
            "Integración con vivienda, alimentación y descanso: el paciente mayor es cliente de los cuatro sectores en el mismo mes.",
        },
      ],
    },
    construccion: {
      resumen:
        "Fusagasugá y Silvania llevan años recibiendo segunda vivienda, vivienda de retiro y proyectos de finca. Detrás de cada obra hay una cadena local que el CEZ quiere fortalecer.",
      contexto: [
        "La demanda de vivienda en la provincia tiene un motor claro: familias de Bogotá que buscan segunda vivienda, personas que llegan a vivir su retiro y proyectos de finca con servicios. Esa demanda sostiene a constructores, ferreterías, transportadores, maestros y proveedores locales.",
        "El reto no es que falte mercado: es construir con reglas claras, mano de obra calificada y sin dañar el paisaje que hace atractiva a la región. La vivienda adaptada para el adulto mayor es la oportunidad más concreta de los próximos años.",
      ],
      datos: [
        { valor: "2", texto: "Motores de demanda: retiro y segunda vivienda desde Bogotá" },
        { valor: "70+", texto: "Vivienda adaptada: el producto que casi nadie ofrece hoy" },
        { valor: "100%", texto: "De cada obra formal derrama en ferreterías y maestros locales" },
        { valor: "1", texto: "Interlocución técnica unificada ante planeación y servicios" },
      ],
      propuestaIntro:
        "La mesa de construcción ordena la cadena local para que los proyectos arranquen más rápido y el empleo se quede en la provincia.",
      propuesta: [
        {
          titulo: "Una sola interlocución técnica",
          texto:
            "Un canal unificado con planeación municipal y las empresas de servicios públicos, para destrabar licencias y conexiones.",
        },
        {
          titulo: "Banco de proveedores verificados",
          texto:
            "Contratistas, maestros y proveedores de la provincia con referencias verificadas, para que la obra contrate local con confianza.",
        },
        {
          titulo: "Obra segura y acabados",
          texto:
            "Formación local en los oficios que hoy obligan a importar cuadrillas de Bogotá: acabados, alturas y obra segura.",
        },
        {
          titulo: "Vivienda plateada",
          texto:
            "Diseño y remodelación de vivienda para vivir bien a los setenta: sin barreras, segura y bien iluminada. Un mercado que ya existe.",
        },
      ],
    },
    turismo: {
      resumen:
        "El Sumapaz está a la puerta de Bogotá, con clima estable, fincas, gastronomía y naturaleza. El reto no es atraer gente: es llenar la semana y no solo el domingo.",
      contexto: [
        "La provincia recibe visitantes todos los fines de semana, pero concentrados en dos días que dejan poco margen. Hoteles, restaurantes y fincas cargan nómina fija toda la semana con ingresos de viernes a domingo.",
        "La oportunidad está en el turismo de semana: estadías largas, bienestar, descanso, eventos corporativos y visitas de familias que vienen a ver a sus mayores. Ese producto requiere trabajar en bloque: nadie llena un martes solo.",
      ],
      datos: [
        { valor: "2h", texto: "De Bogotá: el mercado emisor más grande del país" },
        { valor: "7/7", texto: "La meta: ocupación de semana, no solo de domingo" },
        { valor: "18°C", texto: "Clima estable todo el año para estadías largas" },
        { valor: "1", texto: "Marca única de provincia para promocionarse en Bogotá" },
      ],
      propuestaIntro:
        "La mesa de turismo construye el producto de semana y una sola marca de provincia para venderlo en Bogotá.",
      propuesta: [
        {
          titulo: "Producto de semana",
          texto:
            "Planes de estadías largas, bienestar, descanso y eventos corporativos que llenan lunes a viernes, no solo el puente.",
        },
        {
          titulo: "Formalización acompañada",
          texto:
            "Registro, seguros y facturación sin discursos: acompañamiento práctico para que cumplir no sea una desventaja.",
        },
        {
          titulo: "Promoción conjunta",
          texto:
            "Una sola marca del Sumapaz en Bogotá, con vocería única ante operadores, cajas de compensación y empresas.",
        },
        {
          titulo: "Gastronomía de origen",
          texto:
            "Menús con productos de la provincia: el turismo compra local y la agroindustria gana un canal estable.",
        },
      ],
    },
    agroindustria: {
      resumen:
        "Café, mora, frutales, panela, lácteos, avicultura y flores. El Sumapaz produce bien pero vende barato: entrega materia prima y compra de vuelta el producto terminado.",
      contexto: [
        "La provincia tiene vocación agrícola comprobada y acceso directo al mercado más grande del país. Sin embargo, el margen se queda en la intermediación: los precios se deciden lejos de la finca y la transformación ocurre en otra parte.",
        "El camino es conocido: comprar insumos en volumen, transformar y empacar aquí, construir marca de origen y venderle primero a la propia provincia — hoteles, restaurantes, colegios y centros de cuidado que hoy compran en Bogotá.",
      ],
      datos: [
        { valor: "7", texto: "Líneas productivas: café, mora, frutales, panela, lácteos, avicultura y flores" },
        { valor: "1ª", texto: "Meta: marca de origen del Sumapaz con reglas de calidad" },
        { valor: "-30%", texto: "Objetivo de costo en insumos con compras en volumen" },
        { valor: "0 km", texto: "Vender primero aquí: hoteles, colegios y centros de cuidado" },
      ],
      propuestaIntro:
        "La mesa de agroindustria captura el margen que hoy se queda en la intermediación: compra junta, transforma aquí y vende con marca propia.",
      propuesta: [
        {
          titulo: "Compra conjunta de insumos",
          texto:
            "Fertilizantes, empaque y transporte negociados en volumen real, para bajar el costo de producir en la provincia.",
        },
        {
          titulo: "Marca de origen Sumapaz",
          texto:
            "Una marca con reglas mínimas de calidad verificables que diferencia el producto de la provincia en Bogotá.",
        },
        {
          titulo: "Transformación local",
          texto:
            "Del cultivo al producto terminado: empaque, valor agregado y margen que se queda en la finca y no en la intermediación.",
        },
        {
          titulo: "Mercado interno primero",
          texto:
            "Venta directa a los hoteles, restaurantes, colegios y centros de cuidado de la provincia, con volúmenes y frecuencia acordados.",
        },
      ],
    },
  },
};

const en = {
  labels: {
    eyebrow: "Strategic sector · CEZ",
    contextoLabel: "The sector in context",
    datosLabel: "Quick facts",
    propuestaLabel: "Value proposition",
    retosLabel: "What holds us back today",
    mesaLabel: "What the sector table does",
    volver: "Back to Sectors",
    saberMas: "Learn more",
    ctaTitle: "Is your company in this sector?",
    ctaBody: "Join the sector table and take part in decisions, joint purchasing, and business among members.",
    cta: "I want to join this table",
  },
  sectores: {
    salud: {
      resumen:
        "Fusagasugá serves patients from across the province and welcomes more older adults every year. Health is the heart of Sumapaz's silver economy.",
      contexto: [
        "The province works as a regional healthcare hub: clinics, care centers, laboratories, pharmacies, therapy practices, and home services attend the ten municipalities and visitors from Bogotá.",
        "The country's aging trend favors Sumapaz: every year more people choose the region for retirement thanks to its climate, proximity to the capital, and cost of living. That makes care a stable market that does not depend on weekends or harvests.",
      ],
      datos: [
        { valor: "10", texto: "Municipalities relying on health services in Fusagasugá" },
        { valor: "2h", texto: "From Bogotá: patients and families visit with ease" },
        { valor: "60+", texto: "The senior population grows faster than the national average" },
        { valor: "365", texto: "Days of demand: care has no low season" },
      ],
      propuestaIntro:
        "The CEZ health table turns a fragmented sector into a bloc that negotiates, trains, and purchases together.",
      propuesta: [
        {
          titulo: "Bloc negotiation",
          texto:
            "Payment terms negotiated jointly with payers. A clinic alone waits; sixty companies negotiating as a bloc get answers.",
        },
        {
          titulo: "Talent trained here",
          texto:
            "Nursing aides and caregivers trained with local academic partners, to stop losing skilled staff to Bogotá.",
        },
        {
          titulo: "Joint purchasing",
          texto:
            "Medical and care supplies bought in volume to lower each member's unit cost.",
        },
        {
          titulo: "Silver Fusagasugá network",
          texto:
            "Integration with housing, food, and leisure: the older patient is a client of all four sectors in the same month.",
        },
      ],
    },
    construccion: {
      resumen:
        "Fusagasugá and Silvania have spent years receiving second homes, retirement housing, and countryside projects. Behind every build is a local chain the CEZ wants to strengthen.",
      contexto: [
        "Housing demand in the province has a clear driver: Bogotá families looking for second homes, people arriving for retirement, and countryside projects with services. That demand sustains local builders, hardware stores, hauliers, foremen, and suppliers.",
        "The challenge is not lack of market: it is building with clear rules, skilled labor, and without damaging the landscape that makes the region attractive. Senior-adapted housing is the most concrete opportunity of the coming years.",
      ],
      datos: [
        { valor: "2", texto: "Demand drivers: retirement and second homes from Bogotá" },
        { valor: "70+", texto: "Adapted housing: the product almost nobody offers today" },
        { valor: "100%", texto: "Of each formal build spills over to local suppliers" },
        { valor: "1", texto: "Unified technical channel with planning and utilities" },
      ],
      propuestaIntro:
        "The construction table organizes the local chain so projects start faster and jobs stay in the province.",
      propuesta: [
        {
          titulo: "One technical channel",
          texto:
            "A unified channel with municipal planning and utility companies to unblock permits and connections.",
        },
        {
          titulo: "Verified supplier bank",
          texto:
            "Contractors, foremen, and suppliers from the province with verified references, so builds can hire local with confidence.",
        },
        {
          titulo: "Safe work and finishes",
          texto:
            "Local training in the trades that today force crews to be imported from Bogotá: finishes, heights, and site safety.",
        },
        {
          titulo: "Silver housing",
          texto:
            "Design and retrofitting of homes for living well at seventy: barrier-free, safe, and well lit. A market that already exists.",
        },
      ],
    },
    turismo: {
      resumen:
        "Sumapaz sits at Bogotá's doorstep, with steady weather, farms, food, and nature. The challenge is not attracting people: it is filling the week, not just Sunday.",
      contexto: [
        "The province receives visitors every weekend, but packed into two days that leave thin margins. Hotels, restaurants, and farms carry fixed payroll all week with revenue from Friday to Sunday.",
        "The opportunity is weekday tourism: long stays, wellness, rest, corporate events, and families visiting their elders. That product requires working as a bloc: nobody fills a Tuesday alone.",
      ],
      datos: [
        { valor: "2h", texto: "From Bogotá: the country's largest source market" },
        { valor: "7/7", texto: "The goal: weekday occupancy, not just Sundays" },
        { valor: "18°C", texto: "Stable climate year-round for long stays" },
        { valor: "1", texto: "Single province brand to promote in Bogotá" },
      ],
      propuestaIntro:
        "The tourism table builds the weekday product and a single province brand to sell it in Bogotá.",
      propuesta: [
        {
          titulo: "Weekday product",
          texto:
            "Long-stay, wellness, rest, and corporate event packages that fill Monday to Friday, not just long weekends.",
        },
        {
          titulo: "Guided formalization",
          texto:
            "Registration, insurance, and invoicing without lectures: practical support so compliance is not a disadvantage.",
        },
        {
          titulo: "Joint promotion",
          texto:
            "One Sumapaz brand in Bogotá, with a single voice before operators, compensation funds, and companies.",
        },
        {
          titulo: "Food with origin",
          texto:
            "Menus built on the province's products: tourism buys local and agribusiness gains a stable channel.",
        },
      ],
    },
    agroindustria: {
      resumen:
        "Coffee, blackberries, fruit, panela, dairy, poultry, and flowers. Sumapaz produces well but sells cheap: it ships raw material and buys back the finished product.",
      contexto: [
        "The province has proven agricultural vocation and direct access to the country's largest market. Yet the margin stays in intermediation: prices are set far from the farm and processing happens elsewhere.",
        "The path is known: buy inputs in volume, process and package here, build an origin brand, and sell first to the province itself — hotels, restaurants, schools, and care centers that currently buy in Bogotá.",
      ],
      datos: [
        { valor: "7", texto: "Product lines: coffee, blackberries, fruit, panela, dairy, poultry, and flowers" },
        { valor: "1st", texto: "Goal: a Sumapaz origin brand with quality rules" },
        { valor: "-30%", texto: "Input cost target through volume purchasing" },
        { valor: "0 km", texto: "Sell here first: hotels, schools, and care centers" },
      ],
      propuestaIntro:
        "The agribusiness table captures the margin that today stays in intermediation: buy together, process here, and sell under an own brand.",
      propuesta: [
        {
          titulo: "Joint input purchasing",
          texto:
            "Fertilizers, packaging, and transport negotiated in real volume to lower the cost of producing in the province.",
        },
        {
          titulo: "Sumapaz origin brand",
          texto:
            "A brand with verifiable minimum quality rules that sets the province's products apart in Bogotá.",
        },
        {
          titulo: "Local processing",
          texto:
            "From crop to finished product: packaging, added value, and margin that stays on the farm rather than in intermediation.",
        },
        {
          titulo: "Home market first",
          texto:
            "Direct sales to the province's hotels, restaurants, schools, and care centers, with agreed volumes and frequency.",
        },
      ],
    },
  },
};

export const cezSectorDetalle = { es, en };

export const getCezSectorDetalle = (lang, sectorId) => {
  const data = cezSectorDetalle[lang] || cezSectorDetalle.es;
  const detalle = data.sectores[sectorId];
  return detalle ? { labels: data.labels, detalle } : null;
};
